import React, { useEffect, useState } from 'react';
import {
  TitleContainer,
  ModalTitle,
  StyledButton,
  ButtonText,
  ButtonContainer,
  TextContainer,
  Message,
  TableContainer,
  StyledTable,
  StyledTh,
  StyledTd,
  PageButton,
  PageCountContainer,
  Loader,
  XIcon,
} from './ModalComponent.styles';
import Modal from './Modal';
import { Waveform } from '@uiball/loaders';

import { formatDateMonthDay, priceFormatter } from '../../utils/utils';
import { useSelector } from 'react-redux';
import { selectPaymentIntents } from '../../store/slice/vendor/slice';

const HistoryModal = ({ open, onClose, width, loading, onPageChange }) => {
  const [page, setPage] = useState(1);
  const paymentIntents = useSelector(selectPaymentIntents);

  const perPage = paymentIntents.perPage;
  const total = paymentIntents.total;
  const totalPages = Math.ceil(total / perPage);

  // const startIndex = (paymentIntents.page - 1) * perPage;
  // const endIndex = startIndex + perPage;

  const handlePageChange = newPage => {
    setPage(newPage);
    onPageChange(newPage);
  };

  const handleKeyDown = e => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <Modal isOpen={open} width={width} onClose={onClose} fade>
      <div>
        <TitleContainer>
          <ModalTitle>History</ModalTitle>
          <XIcon onClick={onClose} />
        </TitleContainer>

        {!loading ? (
          <>
            {paymentIntents.data.length <= 0 ? (
              <TextContainer>
                <Message>You currently have no earnings statements in history.</Message>
              </TextContainer>
            ) : (
              <>
                <TableContainer>
                  <StyledTable>
                    <thead>
                      <tr>
                        <StyledTh>Card</StyledTh>
                        <StyledTh>Date</StyledTh>
                        <StyledTh $right>Amount</StyledTh>
                      </tr>
                    </thead>
                    <tbody>
                      {paymentIntents.data.map((val, key) => {
                        return (
                          <tr key={key}>
                            <StyledTd>**** {val.payment_method.last4}</StyledTd>
                            <StyledTd>{formatDateMonthDay(val.createdAt)}</StyledTd>
                            <StyledTd $right>${priceFormatter(val.amount)}</StyledTd>
                          </tr>
                        );
                      })}
                    </tbody>
                  </StyledTable>
                </TableContainer>
                {totalPages === 1 && <div style={{ marginBottom: 40 }} />}
                {totalPages !== 1 && (
                  <PageCountContainer>
                    {Array.from({ length: totalPages }, (_, index) => (
                      <PageButton
                        key={index}
                        onClick={() => {
                          handlePageChange(index + 1);
                        }}
                        style={{
                          backgroundColor: page === index + 1 ? '#be6a5922' : 'transparent',
                          borderRadius: page === index + 1 ? '50%' : 0,
                          border: page === index + 1 ? '1px solid #be6a59' : 'transparent',
                        }}>
                        {index + 1}
                      </PageButton>
                    ))}
                  </PageCountContainer>
                )}
              </>
            )}
          </>
        ) : (
          <Loader>
            <Waveform size={26} lineWeight={3.5} speed={1} color="#be6a59" />
          </Loader>
        )}
      </div>
      <ButtonContainer>
        <StyledButton onClick={onClose}>
          <ButtonText>Cancel</ButtonText>
        </StyledButton>
      </ButtonContainer>
    </Modal>
  );
};

export default HistoryModal;
